import { useRef, useState } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { IoLocationSharp } from "react-icons/io5";
import { FaCalculator, FaTruckRampBox } from "react-icons/fa6";
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import { SlLocationPin } from "react-icons/sl";
import Select from 'react-select';
import { TbLocationPin } from "react-icons/tb";
import { AiTwotoneSafetyCertificate } from "react-icons/ai";
import { GrSystem, GrSchedules } from "react-icons/gr";
import { GiSkills } from "react-icons/gi";
import { Link, useLocation } from 'react-router-dom';
import { BsBox } from 'react-icons/bs';
import SpinLoader from '../components/SpinLoader.js';
import axios from 'axios';
import { GoCircle } from 'react-icons/go';
import CalculateHeader from './CalculateHeader.js';
import { FaSyncAlt, FaMapMarkerAlt } from "react-icons/fa";
import CalculateRateShowHeader from './CalculateRateShowHeader.js';
import { RiWeightLine } from 'react-icons/ri';
import PriceCalculator from '../DocumentShiping/priceCalculator.js';
import { MdOutlinePayment } from 'react-icons/md';
import { CALCULATE_CUSTOMER_RATE, GET_VILLAGES_BY_PINCODE, PINCODE_SERVICEABLE } from '../graphql/Query/Order.js';
import { useLazyQuery, useQuery } from '@apollo/client';
import { GET_USER_FRANCHISE_DETAILS } from '../graphql/Query/GetReceiverOfCustomer.js';
import { toast } from 'react-toastify';
import { useEffect } from 'react';


const validationSchema = Yup.object({
    pickUpPincode: Yup.string()
        .required('Pincode is required')
        .matches(/^[0-9]{6}$/, 'Pincode must be exactly 6 digits'),
    deliveryPincode: Yup.string()
        .required('Pincode is required')
        .matches(/^[0-9]{6}$/, 'Pincode must be exactly 6 digits'),
    weight: Yup.string().required('Weight is required'),
    paymentType: Yup.string()
        .required('Payment Type is required'), // Validation for Payment Type
    // codValue: Yup.string().required('COD value is required'),
    // codValue: Yup.string().when('paymentType', {
    //     is: 'Cash on Delivery(COD)', // Apply validation only for COD
    //     then: Yup.string().required('COD value is required'), // Required for COD
    //     otherwise: Yup.string().nullable(), // Optional for other payment types
    //   }),
});
const CalculatorCourier = () => {
    const setFieldValueRef = useRef(null);
    const set = setFieldValueRef?.current;
    const dropdownRef = useRef(null);
    const [calculateRateData] = useLazyQuery(CALCULATE_CUSTOMER_RATE, {
        fetchPolicy: "cache-and-network"
    });
    // useScrollToTop();
    const [checkServiceability] = useLazyQuery(PINCODE_SERVICEABLE, {
        fetchPolicy: "cache-and-network"
    });
    const [filteredVillages, setfilteredVillages] = useState("");

    const [showRoute, setShowRoute] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [pincodeInfo, setPincodeInfo] = useState(null);
    const [selectedVillageInfo, setSelectedVillageInfo] = useState(null);
    const [villages, setVillageOptions] = useState([]);
    const [villagesData, setVillageOptionsData] = useState([]);
    const [showVillageField, setShowVillageField] = useState(false);
    const [villageSearch, setVillageSearch] = useState('');
    const [isOriginServiceable, setIsOriginServiceable] = useState(true);

    const [isOriginVillageCase, setIsOriginVillageCase] = useState(false);
    const [originVillageMessage, setOriginVillageMessage] = useState("");
    const [isVillageCase, setIsVillageCase] = useState(false);
    const [villageWarningMessage, setVillageWarningMessage] = useState("");
    const [isDestinationServiceable, setIsDestinationServiceable] = useState(true);

    const { data } = useQuery(GET_USER_FRANCHISE_DETAILS, {
        fetchPolicy: "cache-and-network"
    });

    const info = data?.getUserFranchiseDetails || {};

    const { defaultPrepaidPrice, defaultCodFlightPrice } = info?.franchise || {};

    // // ✅ Dynamic payment options
    const PaymentOptions = [];
    if (defaultPrepaidPrice) PaymentOptions.push({ value: 'prepaid', label: 'Prepaid' });
    if (defaultCodFlightPrice) PaymentOptions.push({ value: 'cod', label: "Cash on Delivery(COD)" });


    // const PaymentOptions = [
    //     { value: "prepaid", label: "Prepaid" },
    //     { value: "cod", label: "Cash on Delivery(COD)" },
    // ];

    // const tableRef = useRef(null);
    const [activeTab, setActiveTab] = useState("Forward");


    const [pickupLocation, setPickupLocation] = useState({ city: '', state: '' });
    const [deliveryLocation, setDeliveryLocation] = useState({ city: '', state: '' });



    const location = useLocation();
    const imageurlcalcy = location?.state?.keyy
    // console.log('✌️imageurlcalcy --->', imageurlcalcy);
    // const [openCal, setOpenCal] = useState(false);
    const [courierCharges, setCourierCharges] = useState([]);
    const [serviceData, setServiceData] = useState({});
    // const { data: getdataWeightCommission } = useQuery(GET_COMMISION_BY_WEIGHT, {
    //     variables: { weight: weight / 1000 }, // Convert grams to kg
    //     skip: !weight,
    // });
    // console.log('✌️getdataWeightCommission ', getdataWeightCommission?.getCommitionByWeight);


    const [fetchVillagesByPincode] = useLazyQuery(GET_VILLAGES_BY_PINCODE, {
        fetchPolicy: "cache-and-network",
    });



    useEffect(() => {
        const filteredVillagesData = villages?.filter(v =>
            v.toLowerCase().includes(villageSearch?.toLowerCase())
        );
        setfilteredVillages(filteredVillagesData);
    }, [villages, villageSearch])
    const handleSubmit = async (values) => {
        try {
            if (!isDestinationServiceable && !isVillageCase) {
                toast.error("Destination pincode is NOT serviceable. Please change it before continuing.");
                return;
            }
            if (!isOriginServiceable && !isOriginVillageCase) {
                toast.error("This pincode is NOT serviceable. Please enter another pincode.");
                return;
            }
            // ✅ Check if pincode info exists
            if (!pincodeInfo || !pincodeInfo?.serviceable) {
                toast.error("This pincode is not serviceable.");
                return;
            }

            // ✅ Check payment type availability
            if (values?.paymentType === "Prepaid" && !pincodeInfo?.isPrepaidAvailable) {
                toast.error("Prepaid is not available for this pincode.");
                return;
            }
            if (values?.paymentType === "COD" && !pincodeInfo?.isCODAvailable) {
                toast.error("COD is not available for this pincode.");
                return;
            }
            if (showRoute === true && pincodeInfo?.villages?.length > 0) {
                // Case 1: No village selected
                if (!selectedVillageInfo) {
                    toast.error("Please select a receiver village.");
                    setShowRoute(false);
                    return;
                }

                // Case 2: Selected village not serviceable
                if (!selectedVillageInfo?.isServiceAvailable) {
                    toast.error(`Village ${selectedVillageInfo?.name || ""} is not serviceable.`);
                    setShowRoute(false);
                    setSelectedVillageInfo(null);


                    set("village", "");

                    return;
                }

                // // Case 3: Selected village pincode mismatch
                // if (
                //     selectedVillageInfo?.pincode !== enteredPincode &&
                //     enteredPincode !== pincodeInfo?.pincode
                // ) {
                //     toast.error("Selected village does not match the entered pincode.");
                //     setShowRoute(false);
                //     setSelectedVillageInfo(null);
                //     return;
                // }
            }
            setServiceData(values);
            // let weight = parseWeight(values?.weight, true);

            const { data, errors } = await calculateRateData({
                variables: {
                    input: {
                        pickupPincode: values?.pickUpPincode,
                        deliveryPincode: values?.deliveryPincode,
                        pickupStateId: pickupLocation?.state,
                        deliveryStateId: deliveryLocation?.state,
                        weight: parseFloat(values?.weight),
                        paymentType: values?.paymentType,
                        codValue: parseFloat(values?.codValue || 0),
                        extraCharge: selectedVillageInfo?.isServiceAvailable && showRoute === true ? selectedVillageInfo?.extraCharge : 0,
                        receiverId: info?.id,
                    },
                },
                errorPolicy: "all",
            });

            if (errors && errors?.length > 0) {
                toast.error(errors[0].message || "Something went wrong");
                return;
            }
            const total = data?.calculateCustomerRate?.collectCustomerCharge;
            if (total) {
                toast.success(`Total Charges: ₹${Number(total?.toFixed(2))}`);
                setCourierCharges([Number(total?.toFixed(2)), 0]);
            }
        } catch (err) {
            const errorMessage =
                err?.graphQLErrors?.[0]?.message ||
                err?.networkError?.result?.errors?.[0]?.message ||
                err?.message || "Something went wrong.";
            toast.error(errorMessage);
        }
    };



    const weightOptions = [
        { value: "0.5 Kg", label: "0.5 kg (500 grams)" },
        { value: "1 Kg", label: "1 kg (1,000 grams)" },
        { value: "2 Kg", label: "2 kg (2,000 grams)" },
        { value: "3 Kg", label: "3 kg (3,000 grams)" },
        { value: "4 Kg", label: "4 kg (4,000 grams)" },
        { value: "5 Kg", label: "5 kg (5,000 grams)" },
        { value: "6 Kg", label: "6 kg (6,000 grams)" },
        { value: "7 Kg", label: "7 kg (7,000 grams)" },
        { value: "8 Kg", label: "8 kg (8,000 grams)" },
        { value: "9 Kg", label: "9 kg (9,000 grams)" },
        { value: "10 Kg", label: "10 kg (10,000 grams)" },
        { value: "11 Kg", label: "11 kg (11,000 grams)" },
        { value: "12 Kg", label: "12 kg (12,000 grams)" },
        { value: "13 Kg", label: "13 kg (13,000 grams)" },
        { value: "14 Kg", label: "14 kg (14,000 grams)" },
        { value: "15 Kg", label: "15 kg (15,000 grams)" },
        { value: "16 Kg", label: "16 kg (16,000 grams)" },
        { value: "17 Kg", label: "17 kg (17,000 grams)" },
        { value: "18 Kg", label: "18 kg (18,000 grams)" },
        { value: "19 Kg", label: "19 kg (19,000 grams)" },
        { value: "20 Kg", label: "20 kg (20,000 grams)" },
        { value: "21 Kg", label: "21 kg (21,000 grams)" },
        { value: "22 Kg", label: "22 kg (22,000 grams)" },
        { value: "23 Kg", label: "23 kg (23,000 grams)" },
        { value: "24 Kg", label: "24 kg (24,000 grams)" },
        { value: "25 Kg", label: "25 kg (25,000 grams)" },
        { value: "26 Kg", label: "26 kg (26,000 grams)" },
        { value: "27 Kg", label: "27 kg (27,000 grams)" },
        { value: "28 Kg", label: "28 kg (28,000 grams)" },
        { value: "29 Kg", label: "29 kg (29,000 grams)" },
        { value: "30 Kg", label: "30 kg (30,000 grams)" },
    ];
    const handleReset = (resetForm) => {
        resetForm({
            values: {
                pickUpPincode: '',
                deliveryPincode: '',
                weight: '',
                length: '',
                height: '',
                breadth: '',
                paymentType: '',
                codValue: '',

            }
        });
    };


    const handlePincodeCheck = async (type, pincode) => {
        try {
            const variables = type === 'origin'
                ? { originPincode: Number(pincode) }
                : { destinationPincode: Number(pincode) };

            const { data } = await checkServiceability({ variables });

            if (!data?.checkPincodeServiceability) return false;

            const result = data.checkPincodeServiceability;

            // --- Village case ---
            if (
                result.destination === false &&
                result.destinationReason === "VILLAGE_NOT_SERVICEABLE_COLLECT_FROM_MAIN_BRANCH"
            ) {
                setIsVillageCase(true);
                setIsDestinationServiceable(true); // <-- important: TRUE
                const msg = `Delivery village not serviceable. Receiver must COLLECT parcel from:
                ${result.destinationLastCenter?.officeMainArea
                        ? result?.destinationLastCenter.officeMainArea + ", "
                        : ""}${result?.destinationLastCenter?.officeCity} - ${result?.destinationMainPincode}`;

                toast.info(msg);

                setVillageWarningMessage(msg); // <-- Save message for UI
                // IMPORTANT: Do NOT show village dropdown here
                setShowVillageField(false);
                setShowRoute(false);

                return true;
            }

            // --- Fully Not Serviceable ---
            if (result.destination === false) {
                setIsVillageCase(false);
                setIsDestinationServiceable(false);
                toast.error("Destination pincode is NOT serviceable");
                return false;
            }

            if (type === "origin") {
                // ----- Village Case -----
                if (!result.origin && result.originReason === "VILLAGE_NOT_SERVICEABLE_COLLECT_FROM_MAIN_BRANCH") {

                    setIsOriginVillageCase(true);       // ✔ mark as village case
                    setIsOriginServiceable(true);       // ✔ still serviceable from main center


                    const message = `Pickup village not serviceable. Please DROP your parcel at main branch: ${result.originLastCenter?.officeMainArea
                        ? result.originLastCenter.officeMainArea + ", "
                        : ""
                        }${result.originLastCenter?.officeCity} - ${result.originMainPincode}`;

                    toast.info(message);
                    setOriginVillageMessage(message);

                    return true;
                }

                // ----- Not Serviceable -----
                if (!result.origin) {
                    setIsOriginVillageCase(false);     // ❌ not village case
                    setIsOriginServiceable(false);     // ❌ show red error
                    toast.error("Origin pincode is NOT serviceable");
                    return false;
                }

                // ----- Fully Serviceable -----
                setIsOriginVillageCase(false);
                setIsOriginServiceable(true);
                return true;
            }

            // --- Fully Serviceable ---
            setIsVillageCase(false);
            setIsDestinationServiceable(true);
            return true;

        } catch (error) {
            setIsDestinationServiceable(false);
            setIsVillageCase(false);
            setIsOriginServiceable(false);
            toast.error("Unable to check serviceability");
            return false;
        }
    };

    const handleChange = async (e, setFieldValue, fieldName, type) => {
        const pincode = e.target.value.trim();
        setFieldValue(fieldName, pincode);
        if (type === 'delivery') {
            setFieldValue(fieldName, pincode);
            setFieldValue('village', "");
            setVillageOptions([]);
            // setfilteredVillages([]);
            setVillageOptionsData([]);
            setSelectedVillageInfo(null);
            setShowVillageField(false);
            setShowDropdown(false);
            setShowRoute(false);
            setIsDestinationServiceable(true);
            setIsVillageCase(false);
            setVillageWarningMessage("");
        }


        if (pincode?.length === 6) {
            try {
                if (type === "delivery") {
                    const serviceable = await handlePincodeCheck("destination", pincode); // ✅ use return value
                    // Continue only if serviceable
                    if (serviceable) {
                        await fetchVillagesByPincode({
                            variables: { pincode: parseInt(pincode, 10) },
                            onCompleted: (data) => {
                                const pincodeData = data?.getVillagesByPincode || null;
                                setPincodeInfo(pincodeData);

                                const villages = pincodeData?.villages || [];
                                setVillageOptionsData(villages);
                                setVillageOptions(villages.map(v => v?.name));

                                if (villages?.length === 0) {
                                    setShowVillageField(false);
                                    setShowRoute(false);
                                    setSelectedVillageInfo(null);
                                    return; // IMPORTANT — stop here
                                }


                                // ✅ If only one village (means it's a direct village pincode)
                                if (villages?.length === 1) {
                                    const village = villages[0];
                                    setSelectedVillageInfo(village);
                                    setfilteredVillages([village?.name]); // show only that one
                                    setVillageOptions([village?.name]); // dropdown list = single village
                                    setShowVillageField(true); // SHOW FIELD
                                    return;
                                }
                                // CASE 3: Multiple villages → show dropdown & radio buttons
                                setShowVillageField(true);
                            },

                            onError: () => {
                                setVillageOptions([]);
                                setShowVillageField(false);
                                setPincodeInfo(null);
                            },
                        });
                    }
                } else if (type === 'pickup') {
                    await handlePincodeCheck("origin", pincode);
                }
                const response = await axios.get(`https://api.postalpincode.in/pincode/${pincode}`);
                const data = response?.data;
                if (data[0].Status === 'Success') {
                    const { District, State } = data[0].PostOffice[0];
                    if (fieldName === 'pickUpPincode') {
                        setPickupLocation({ city: District, state: State });
                    } else if (fieldName === 'deliveryPincode') {
                        setDeliveryLocation({ city: District, state: State });
                    }
                } else {
                    if (fieldName === 'pickUpPincode') {
                        setPickupLocation({ city: '', state: '' });
                    } else if (fieldName === 'deliveryPincode') {
                        setDeliveryLocation({ city: '', state: '' });
                    }
                }
            } catch (err) {
                console.error('Error fetching pincode info:', err);
            }
        }
    };

    return (
        <>
            <Header />
            <div className="relative isolate overflow-hidden bg-slate-900 py-16 sm:pt-14">
                <img
                    src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/tailwindimg.avif"
                    alt=""
                    className="absolute inset-0 -z-10 h-full w-full object-cover object-right md:object-center"
                />
                <div
                    className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl"
                    aria-hidden="true"
                >
                    <div
                        className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>
                <div
                    className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
                    aria-hidden="true"
                >
                    <div
                        className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>
                <div className="mx-auto max-w-auto md:px-8 lg:px-8">
                    <div className='flex flex-col lg:flex-row lg:space-x-3 gap-y-10'>
                        <div className="lg:w-2/3 md:rounded-l-lg rounded-none md:py-8 md:px-9 p-6 bg-white ring-1 ring-slate-900/5 shadow-md">
                            <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 space-y-3 sm:space-y-0">
                                {/* Left Section - Icon & Title */}
                                <div className="flex items-center">
                                    <BsBox className="text-2xl me-3 text-gray-800 drop-shadow-lg ms-2" />
                                    <h1 className="text-lg sm:text-xl font-bold">
                                        Domestic Rates Calculator
                                    </h1>
                                </div>

                                {/* Right Section - Refresh Button */}
                                <button
                                    onClick={() => window.location.reload()}
                                    className="flex items-center justify-center gap-2 text-xs sm:text-sm px-4 py-1 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full sm:w-auto"
                                >
                                    <FaSyncAlt /> Refresh
                                </button>
                            </div>

                            <p className="mb-5 text-sm">Our free calculator helps you calculate Shipment charges based on everything that matters.</p>

                            <CalculateHeader />
                            {info?.franchise ? (
                                <Formik
                                    initialValues={{
                                        pickUpPincode: '',
                                        deliveryPincode: '',
                                        weight: '',
                                        length: '',
                                        height: '',
                                        breadth: '',
                                        paymentType: '', // This must be included
                                        codValue: '',
                                        village: "",
                                    }}
                                    validationSchema={validationSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {({ isSubmitting, resetForm, setFieldValue, errors, touched, values }) => {
                                        setFieldValueRef.current = setFieldValue;
                                        return (
                                            <>
                                                <Form>
                                                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 mt-7 gap-6'>

                                                        <div>
                                                            <label>Pickup Pincode <span className="text-red-500">*</span></label>
                                                            <div className="mt-2">
                                                                <div className="flex items-center border border-slate-700 p-1.5 rounded-md">
                                                                    <IoLocationSharp className="text-gray-500 mr-2" />
                                                                    <Field
                                                                        type="text"
                                                                        name="pickUpPincode"
                                                                        className="w-full bg-transparent focus:bg-none select-bg-transparent focus:outline-none"
                                                                        placeholder="Pick-up"
                                                                        onChange={(e) => handleChange(e, setFieldValue, 'pickUpPincode', "pickup")}
                                                                    />
                                                                </div>
                                                                <ErrorMessage name="pickUpPincode" component="div" className="text-red-600 text-sm mt-1" />
                                                                {pickupLocation.city && pickupLocation.state && (
                                                                    <div className="text-green-600 text-sm mt-1 flex items-center space-x-1">
                                                                        <FaMapMarkerAlt className="text-green-600" />
                                                                        <span>{pickupLocation.city}, {pickupLocation.state}</span>
                                                                    </div>
                                                                )}
                                                                {!isOriginServiceable && !isOriginVillageCase && (
                                                                    <div className="text-red-500 text-sm mt-1">
                                                                        This pincode is NOT serviceable.
                                                                    </div>
                                                                )}
                                                                {isOriginVillageCase && originVillageMessage && (
                                                                    <div className="text-yellow-600 text-sm mt-1">
                                                                        {originVillageMessage}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div>
                                                            <label>Delivery Pincode <span className="text-red-500">*</span></label>
                                                            <div className="mt-2">
                                                                <div className="flex items-center border border-slate-700 p-1.5 rounded-md">
                                                                    <IoLocationSharp className="text-gray-500 mr-2" />
                                                                    <Field
                                                                        type="text"
                                                                        name="deliveryPincode"
                                                                        className="w-full focus:outline-none"
                                                                        placeholder="Delivery"

                                                                        onChange={(e) => { handleChange(e, setFieldValue, "deliveryPincode", "delivery") }}
                                                                    />
                                                                </div>
                                                                {pincodeInfo && (!pincodeInfo?.isPrepaidAvailable || !pincodeInfo?.isCODAvailable) && (
                                                                    <div className="mt-2 text-xs text-gray-700 bg-gray-100 px-3 py-2 rounded-md border border-gray-300">
                                                                        {!pincodeInfo?.isPrepaidAvailable ? <p>Prepaid: {pincodeInfo?.isPrepaidAvailable ? "Available" : "Not Available"}</p> : ""}
                                                                        {!pincodeInfo?.isCODAvailable ? <p>COD: {pincodeInfo?.isCODAvailable ? "Available" : "Not Available"}</p> : ""}
                                                                    </div>
                                                                )}

                                                                {!isDestinationServiceable && !isVillageCase && (
                                                                    <div className="text-red-500 text-sm mt-1">
                                                                        This pincode is NOT serviceable.
                                                                    </div>
                                                                )}
                                                                {/* ⚠️ Village not serviceable but main branch possible */}
                                                                {isVillageCase && villageWarningMessage && (
                                                                    <div className="text-yellow-600 text-sm mt-1">
                                                                        {villageWarningMessage}
                                                                    </div>
                                                                )}
                                                                <ErrorMessage name="deliveryPincode" component="div" className="text-red-600 text-sm mt-1" />
                                                                {deliveryLocation.city && deliveryLocation.state && (
                                                                    <div className="text-green-600 text-sm mt-1 flex items-center space-x-1">
                                                                        <FaMapMarkerAlt className="text-green-600" />
                                                                        <span>{deliveryLocation.city}, {deliveryLocation.state}</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {showVillageField && isDestinationServiceable && !isVillageCase && (
                                                            <div className="relative" ref={dropdownRef}>
                                                                <label className="block text-sm font-medium text-slate-700 mb-1">
                                                                    Receiver Village <span className="text-red-500">*</span>
                                                                </label>
                                                                {showRoute === true &&
                                                                    <div
                                                                        className={`w-full px-4 py-2 bg-blue-50 rounded-md border text-sm placeholder-gray-600 focus:outline-none focus:ring-1 focus:ring-slate-900 ${errors.village && touched.village
                                                                            ? 'border-red-500'
                                                                            : 'border-zinc-300'
                                                                            }`}
                                                                        onClick={() => setShowDropdown(prev => !prev)}
                                                                    >
                                                                        {values.village || 'Select village'}
                                                                    </div>
                                                                }
                                                                <ErrorMessage
                                                                    name="village"
                                                                    component="div"
                                                                    className="text-red-500 text-sm mt-1"
                                                                />

                                                                {showDropdown && (
                                                                    <div className="absolute z-10 mt-1 w-full bg-blue-50 border rounded-md max-h-60 overflow-y-auto">
                                                                        <input
                                                                            type="text"
                                                                            placeholder="Search village..."
                                                                            className="w-full bg-blue-50 px-3 py-3 border-b outline-none"
                                                                            value={villageSearch}
                                                                            onChange={e => setVillageSearch(e.target.value)}
                                                                        />
                                                                        {filteredVillages.map((village, idx) => (
                                                                            <div
                                                                                key={idx}
                                                                                onClick={() => {
                                                                                    setFieldValue('village', village);
                                                                                    setShowDropdown(false);
                                                                                    setVillageSearch('');

                                                                                    // Save the full village object (not just name)
                                                                                    const selected = villagesData?.find(v => v?.name === village); // FIXED: using villagesData (array)
                                                                                    // console.log('✌️villages --->', villagesData);
                                                                                    // console.log('✌️selected --->', selected);

                                                                                    setSelectedVillageInfo(selected); // ✅ This stores the selected village info properly
                                                                                }}
                                                                                className="px-4 py-2.5 text-gray-800 hover:bg-slate-700 hover:text-white active:bg-slate-800 cursor-pointer"
                                                                            >
                                                                                {village}
                                                                            </div>
                                                                        ))}
                                                                        {filteredVillages.length === 0 && (
                                                                            <div className="px-4 py-2.5 text-sm text-gray-400">No match found</div>
                                                                        )}
                                                                    </div>
                                                                )}

                                                                <div className="space-y-1 mt-1">
                                                                    {/* Radio Buttons */}
                                                                    <div className="flex items-center gap-8 bg-blue-50 p-2 rounded-lg border border-gray-200">
                                                                        {/* Yes Option */}
                                                                        <label className="flex items-center gap-2 cursor-pointer">
                                                                            <input
                                                                                type="radio"
                                                                                name="showRoute"
                                                                                value="yes"

                                                                                checked={showRoute === true}
                                                                                onChange={() => setShowRoute(true)}
                                                                                className="w-4 h-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                                                            />
                                                                            <span className="text-gray-800 text-sm font-medium">Yes, Deliver (Village)</span>
                                                                        </label>

                                                                        {/* No Option */}
                                                                        <label className="flex items-center gap-2 cursor-pointer">
                                                                            <input
                                                                                type="radio"
                                                                                name="showRoute"
                                                                                value="no"
                                                                                checked={showRoute === false}
                                                                                onChange={() => { setShowRoute(false); setSelectedVillageInfo(null); setFieldValue('village', ""); }}
                                                                                className="w-4 h-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                                                            />
                                                                            <span className="text-gray-800 text-sm font-medium">No, Self Collect</span>
                                                                        </label>
                                                                    </div>

                                                                    {/* Route Info or Message */}
                                                                    {/* Route Info or Message */}
                                                                    {selectedVillageInfo ? (
                                                                        showRoute === false ? (
                                                                            <div className="bg-red-50 border border-red-200 rounded-lg p-2 text-red-600 text-sm font-medium">
                                                                                No, Self Collect Main Branch {pincodeInfo?.lastCenter?.officeMainArea ? pincodeInfo?.lastCenter?.officeMainArea : ""} {pincodeInfo?.lastCenter?.officeCity ? pincodeInfo?.lastCenter?.officeCity : ""} - {pincodeInfo?.lastCenter?.officePincode ? pincodeInfo?.lastCenter?.officePincode : ""}
                                                                            </div>
                                                                        ) : (
                                                                            <div className="text-gray-700 text-sm bg-blue-50 rounded-lg p-2 border border-slate-100 mt-2 space-y-2">
                                                                                <div className="flex justify-between">
                                                                                    <span>Village:</span>
                                                                                    <span className="font-medium">{selectedVillageInfo?.name}</span>
                                                                                </div>
                                                                                <div className="flex justify-between">
                                                                                    <span>Distance from Taluka:</span>
                                                                                    <span className="font-medium">{selectedVillageInfo?.distanceFromTalukaKm} KM</span>
                                                                                </div>
                                                                                <div className="flex justify-between">
                                                                                    <span>Extra Charge:</span>
                                                                                    <span className="font-medium">₹ {selectedVillageInfo?.extraCharge}</span>
                                                                                </div>
                                                                                <div className="flex justify-between">
                                                                                    <span>Service Available:</span>
                                                                                    <span className={`font-medium ${selectedVillageInfo?.isServiceAvailable ? 'text-green-600' : 'text-red-600'}`}>
                                                                                        {selectedVillageInfo?.isServiceAvailable ? 'Yes' : 'No'}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    ) : null}
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="relative z-50">
                                                            <label>Weight (Kg) <span className="text-red-500">*</span></label>
                                                            <div className="mt-2 z-50">
                                                                <Field name="weight">
                                                                    {({ field, form }) => {
                                                                        const selectedOption = weightOptions.find(option => option.value === field.value);
                                                                        return (
                                                                            <Select
                                                                                value={selectedOption || ""}
                                                                                options={weightOptions}
                                                                                className="w-full focus:outline-none z-50"
                                                                                styles={{
                                                                                    control: (base, state) => ({
                                                                                        ...base,
                                                                                        borderColor: state.isFocused ? '#2b2b2b' : '#2b2b2b',
                                                                                        '&:hover': { borderColor: '#2b2b2b' },
                                                                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                                                        zIndex: 1050,
                                                                                    }),
                                                                                    singleValue: (base) => ({
                                                                                        ...base,
                                                                                        color: '#000000',
                                                                                        zIndex: 1050,
                                                                                    }),
                                                                                    option: (base, state) => ({
                                                                                        ...base,
                                                                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                                                                        color: state.isSelected ? 'white' : '#000000',
                                                                                        '&:hover': {
                                                                                            backgroundColor: '#f0f0f0',
                                                                                            color: '#000000',
                                                                                        },
                                                                                        zIndex: 1050,
                                                                                    }),
                                                                                    menu: (base) => ({
                                                                                        ...base,
                                                                                        zIndex: 1050,
                                                                                        position: 'absolute',
                                                                                    }),
                                                                                }}
                                                                                isSearchable={false}
                                                                                placeholder="Select weight"
                                                                                onChange={option => form.setFieldValue(field.name, option.value)}
                                                                                onBlur={() => form.setFieldTouched(field.name, true)}
                                                                            />
                                                                        );
                                                                    }}
                                                                </Field>
                                                                <ErrorMessage name="weight" component="div" className="text-red-600 text-sm mt-1 z-50" />
                                                            </div>
                                                        </div>

                                                        <div className="relative z-40">
                                                            <label>
                                                                Payment Type <span className="text-red-500">*</span>
                                                            </label>
                                                            <div className="mt-2 z-50">
                                                                <Field name="paymentType">
                                                                    {({ field, form }) => {
                                                                        // Find the selected option based on the field value
                                                                        const selectedOption = PaymentOptions.find(
                                                                            (option) => option.value === field.value
                                                                        );

                                                                        return (
                                                                            <div>
                                                                                <Select
                                                                                    value={selectedOption || ""}
                                                                                    options={PaymentOptions}
                                                                                    className="w-full focus:outline-none z-50"
                                                                                    styles={{
                                                                                        control: (base, state) => ({
                                                                                            ...base,
                                                                                            borderColor: '#2b2b2b',
                                                                                            '&:hover': { borderColor: '#2b2b2b' },
                                                                                            boxShadow: state.isFocused
                                                                                                ? '0 0 0 0px #000000'
                                                                                                : 'none',
                                                                                            zIndex: 1050,
                                                                                        }),
                                                                                        singleValue: (base) => ({
                                                                                            ...base,
                                                                                            color: '#000000',
                                                                                            zIndex: 1050,
                                                                                        }),
                                                                                        option: (base, state) => ({
                                                                                            ...base,
                                                                                            backgroundColor: state.isSelected
                                                                                                ? '#000000'
                                                                                                : state.isFocused
                                                                                                    ? '#f0f0f0'
                                                                                                    : 'white',
                                                                                            color: state.isSelected
                                                                                                ? 'white'
                                                                                                : '#000000',
                                                                                            '&:hover': {
                                                                                                backgroundColor: '#f0f0f0',
                                                                                                color: '#000000',
                                                                                            },
                                                                                            zIndex: 1050,
                                                                                        }),
                                                                                        menu: (base) => ({
                                                                                            ...base,
                                                                                            zIndex: 1050,
                                                                                            position: 'absolute',
                                                                                        }),
                                                                                    }}
                                                                                    isSearchable={false}
                                                                                    placeholder="Select Payment Type"
                                                                                    onChange={(option) => {
                                                                                        form.setFieldValue(field.name, option?.value || "");
                                                                                        if (
                                                                                            option?.value === 'cod'
                                                                                        ) {
                                                                                            form.setFieldValue('codValue', ''); // Initialize the input field value
                                                                                        } else {
                                                                                            form.setFieldValue('codValue', null); // Clear the input field for other options
                                                                                        }
                                                                                    }}
                                                                                    onBlur={() => form.setFieldTouched(field.name, true)}
                                                                                />
                                                                            </div>
                                                                        );
                                                                    }}
                                                                </Field>
                                                                <ErrorMessage
                                                                    name="paymentType"
                                                                    component="div"
                                                                    className="text-red-600 text-sm mt-1 z-50"
                                                                />
                                                            </div>
                                                        </div>


                                                        <div>
                                                            <Field name="codValue">
                                                                {({ field, form }) =>
                                                                    form.values.paymentType === 'cod' && (
                                                                        <div>
                                                                            <label>Cod Collectable Value <span className="text-red-500">*</span></label>
                                                                            <div className="mt-2">
                                                                                <div className="flex items-center border border-slate-700 p-1.5 rounded-md">
                                                                                    <Field
                                                                                        type="text"
                                                                                        name="codValue"
                                                                                        className="w-full focus:outline-none"
                                                                                        placeholder="Enter value"
                                                                                        onChange={(e) => {
                                                                                            handleChange(e, setFieldValue, 'codValue');
                                                                                            form.setFieldTouched('codValue', true); // Mark the field as touched
                                                                                        }} />
                                                                                </div>
                                                                                {/* <ErrorMessage name="codValue" component="div" className="text-red-600 text-sm mt-1" /> */}
                                                                                {/* Display the error message only when paymentType is COD */}
                                                                                {form.values.paymentType === 'cod' && !form.values.codValue && (
                                                                                    <div className="text-red-600 text-sm mt-1">
                                                                                        COD value is required.
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                            </Field>
                                                        </div>
                                                    </div>

                                                    {/* </div> */}
                                                    <div className="flex space-x-3 md:space-x-6 justify-end mt-4 md:mt-8">
                                                        <button
                                                            className="cursor-pointer bg-slate-300 text-black px-10 py-1 rounded-md font-semibold text-sm hover:bg-slate-400 transition"
                                                            onClick={() => { resetForm(); setCourierCharges([]); setShowRoute(true); }}
                                                        >
                                                            Reset
                                                        </button>
                                                        <button
                                                            type="submit"
                                                            disabled={isSubmitting}
                                                            className="py-2.5 px-3 w-full inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-slate-800 text-white hover:bg-slate-900 focus:outline-none text-sm"
                                                        >
                                                            {isSubmitting ? (
                                                                <div className="flex items-center">
                                                                    <span className="mr-2">Loading...</span>
                                                                    <SpinLoader /> {/* Replace this with your actual loader component */}
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <FaCalculator className="text-white me-2 text-lg" />
                                                                    Calculate
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>
                                                </Form>
                                            </>
                                        )
                                    }
                                    }
                                </Formik>
                            ) : (
                                <div className="flex items-center mt-2 justify-center py-24 bg-gradient-to-br from-blue-50 to-white">
                                    <div className="max-w-2xl text-center px-6">
                                        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                                            Find Your Shipping Rate
                                        </h2>
                                        <p className="text-gray-600 text-lg leading-relaxed">
                                            To get your exact rate, please contact your nearest{" "}
                                            <span className="font-semibold text-blue-600">AlgarXpress</span> franchise.
                                            Once the rate is finalized, it will automatically appear in our website’s
                                            <span className="font-semibold text-blue-600"> rate calculator</span>.
                                        </p>
                                    </div>
                                </div>

                            )}
                            {/* {imageurlcalcy ? <img src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/1-3_t802.png" className='mt-11 rounded-lg inset-0 isolate hover:opacity-80 overflow-hidden bg-slate-900 h-60 -z-10 w-full object-cover object-right md:object-center' style={{ height: window.innerWidth >= 2500 ? '40vh' : '15rem' }} alt="" /> : <img src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/dbox.jpg" className='mt-11 hover:opacity-80 rounded-lg inset-0 isolate overflow-hidden bg-slate-900 h-60 -z-10 w-full object-cover object-right md:object-center' style={{ height: window.innerWidth >= 2500 ? '40vh' : '15rem' }} alt="" />} */}
                            <div className='text-sm space-y-4 mt-6'>
                                <p>AlgarXpress provides a fully digital, pan-India domestic courier service designed to meet the dynamic needs of modern businesses. From local deliveries to shipping across states, we ensure fast, reliable, and transparent parcel movement through a technology-first approach. Our platform includes a customizable logistics dashboard, giving you complete control over your shipments — schedule pickups, manage orders, track parcels in real-time, and access all records with ease.</p>
                                <p>Every shipment is traceable with live digital tracking, ensuring both you and your customers are always informed. With automated invoicing, instant SMS/email alerts, and integration-ready APIs, our service fits smoothly into your existing business systems. Whether you're an e-commerce seller, manufacturer, distributor, or service provider, AlgarXpress helps you scale your operations confidently with secure handling, prompt deliveries, and full digital transparency.</p>
                                <p>We’re committed to delivering excellence with every parcel, helping your business build trust, save time, and grow faster — across Gujarat and throughout India.</p>
                            </div>
                        </div>
                        <div className="w-full lg:w-1/3 bg-white px-6 py-4 md:rounded-r-lg shadow-md ">
                            {/* {imageurlcalcy ? <img src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/boxs.jpg" alt="" className='rounded-lg hover:opacity-80' /> : <img src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/gg1.jpg" alt="" className='rounded-lg hover:opacity-80' />} */}
                            {/* <h2 className="text-xl font-bold">Billing - Price Calculation</h2> */}

                            {/* <CalculateRateShowHeader /> */}
                            {/* <CalculateRateShowHeader activeTab={activeTab} setActiveTab={setActiveTab} /> */}


                            {/* Header */}
                            <CalculateRateShowHeader activeTab={activeTab} setActiveTab={setActiveTab} />



                            {/* Horizontal Box Layout */}
                            {/* <div className="grid grid-cols-1 gap-4 mt-4"> */}

                            {/* Address Details */}
                            {/* <div className="p-4 bg-slate-50 rounded-lg border border-gray-200"> */}
                            {/* Header Component */}

                            {/* Dynamic Content */}
                            <div className="mt-4">
                                {activeTab === "Forward" ? (
                                    <div>
                                        <div className=" mt-6 mb-4 px-4 sm:px-6">
                                            <Link to='/documentshipping'> <button
                                                type="button"
                                                className="w-full rounded-md bg-slate-800 px-3 py-2 font-semibold text-white shadow-sm hover:bg-slate-900"
                                            // onClick={onClose}
                                            >
                                                Ship Now ₹{courierCharges[0] ? Number(courierCharges[0]?.toFixed(2)) : 0}
                                            </button></Link>

                                        </div>
                                        <div className="flex-1 p-4 bg-white rounded-lg border space-y-6 border-gray-200">
                                            <p className="text-lg font-bold text-gray-800 mb-6">Address Details</p>
                                            <div className="flex space-x-4">
                                                <div className="space-y-1 text-gray-400 flex flex-col items-center">
                                                    <GoCircle className="text-xl" />
                                                    <div className="h-6 border-l-2 border-gray-300"></div>
                                                    <SlLocationPin className="text-xl" />
                                                </div>
                                                <div className="space-y-8">
                                                    <p className="text-sm font-semibold text-gray-700">{serviceData?.pickUpPincode ? serviceData?.pickUpPincode : "-"} <span className="text-gray-500">(Free Pickup)</span></p>
                                                    <p className="text-sm font-semibold text-gray-700">{serviceData?.deliveryPincode ? serviceData?.deliveryPincode : "-"} <span className="text-gray-500">(Delivery)</span></p>
                                                </div>
                                            </div>
                                            <div className='space-y-4'>

                                                <div className="flex justify-between text-sm font-semibold text-gray-700">
                                                    <p>Weight (KG)</p>
                                                    <div className="flex items-center">
                                                        <RiWeightLine className="text-gray-500 text-lg mr-2" />
                                                        <p>{serviceData?.weight ? serviceData?.weight : "-"}</p>
                                                    </div>
                                                </div>

                                                <div className="flex justify-between text-sm font-semibold text-gray-700">
                                                    <p>Payment Type(₹)</p>
                                                    <div className="flex items-center">
                                                        <MdOutlinePayment className="text-gray-500 text-lg mr-2" />
                                                        <p className='uppercase'>{serviceData?.paymentType ? serviceData?.paymentType : "-"}</p>
                                                    </div>
                                                </div>

                                                <div className="flex justify-between text-sm font-semibold text-gray-700">
                                                    <p>COD Collectible Amount (₹)</p>
                                                    <div className="flex items-center">
                                                        <MdOutlinePayment className="text-gray-500 text-lg mr-2" />
                                                        <p className='uppercase'>{serviceData?.codValue ? serviceData?.codValue : 0}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <p className='border border-grey-400'></p>
                                            <div >
                                                <PriceCalculator orderAmount={courierCharges[0] ? Number(courierCharges[0]?.toFixed(2)) : 0} paymentModal='true' />

                                            </div>
                                            <div>
                                                <div className='flex justify-between text-sm md:font-semibold' >
                                                    <p className='text-xl font-semibold'>Total Amount</p>
                                                    <p className='text-xl font-semibold'>₹{courierCharges[0] ? Number(courierCharges[0]?.toFixed(2)) : 0}</p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <div >
                                            <div>
                                                <h3 className="text-sm font-semibold text-gray-800 mb-2">
                                                    1. No RTO Charges for Prepaid Shipment
                                                </h3>
                                            </div>
                                            <div>
                                                <h3 className="text-sm font-semibold text-gray-800 mb-2">
                                                    2. COD Shipments – No Additional RTO Charges
                                                </h3>
                                                <p className="text-xs text-gray-600 leading-relaxed mb-4">
                                                    For COD shipments, the cash collection fee is applied at the time of booking. If the parcel is not delivered and is returned, only the original freight charge and cash collection fee will be charged; no additional RTO fees will apply.
                                                </p>
                                            </div>
                                        </div>
                                        <div className=" mt-6 mb-4 px-4 sm:px-6">
                                            <Link to='/documentshipping'> <button
                                                type="button"
                                                className="w-full rounded-md bg-slate-800 px-3 py-2 font-semibold text-white shadow-sm hover:bg-slate-900"
                                            // onClick={onClose}
                                            >
                                                RTO ₹{courierCharges[1] ? Number(courierCharges[1]?.toFixed(2)) : 0}
                                            </button></Link>

                                        </div>



                                        <div className="flex-1 p-4 bg-white rounded-lg border space-y-6 border-gray-200">
                                            <p className="text-lg font-bold text-gray-800 mb-6">Address Details (RTO)</p>
                                            <div className="flex space-x-4">
                                                <div className="space-y-1 text-gray-400 flex flex-col items-center">
                                                    <GoCircle className="text-xl" />
                                                    <div className="h-6 border-l-2 border-gray-300"></div>
                                                    <SlLocationPin className="text-xl" />
                                                </div>
                                                <div className="space-y-8">
                                                    <p className="text-sm font-semibold text-gray-700">{serviceData?.pickUpPincode ? serviceData?.pickUpPincode : "-"} <span className="text-gray-500">(Delivery)</span></p>
                                                    <p className="text-sm font-semibold text-gray-700">{serviceData?.deliveryPincode ? serviceData?.deliveryPincode : "-"} <span className="text-gray-500">(Return To Origin)</span></p>
                                                </div>
                                            </div>
                                            <div className='space-y-4'>

                                                <div className="flex justify-between text-sm font-semibold text-gray-700">
                                                    <p>Weight (KG)</p>
                                                    <div className="flex items-center">
                                                        <RiWeightLine className="text-gray-500 text-lg mr-2" />
                                                        <p>{serviceData?.weight ? serviceData?.weight : "-"}</p>
                                                    </div>
                                                </div>

                                                <div className="flex justify-between text-sm font-semibold text-gray-700">
                                                    <p>Payment Type(₹)</p>
                                                    <div className="flex items-center">
                                                        <MdOutlinePayment className="text-gray-500 text-lg mr-2" />
                                                        <p className='uppercase'>{serviceData?.paymentType ? serviceData?.paymentType : "-"}</p>
                                                    </div>
                                                </div>

                                                {/* <div className="flex justify-between text-sm font-semibold text-gray-700">
                                                    <p>COD Collectible Amount (₹)</p>
                                                    <div className="flex items-center">
                                                        <MdOutlinePayment className="text-gray-500 text-lg mr-2" />
                                                        <p className='uppercase'>{serviceData?.codValue ? serviceData?.codValue : 0}</p>
                                                    </div>
                                                </div> */}
                                            </div>

                                            <p className='border border-grey-400'></p>
                                            <div >
                                                <PriceCalculator orderAmount={courierCharges[1] ? Number(courierCharges[1]?.toFixed(2)) : 0} paymentModal='true' />

                                            </div>
                                            <div>
                                                <div className='flex justify-between text-sm md:font-semibold' >
                                                    <p className='text-xl font-semibold'>Total Amount</p>
                                                    <p className='text-xl font-semibold'>₹{courierCharges[1] ? Number(courierCharges[1]?.toFixed(2)) : 0}</p>
                                                </div>


                                            </div>

                                        </div>
                                    </div>
                                )}
                            </div>
                            {/* </div> */}

                            {/* <div className="flex-1 p-4 bg-slate-50 rounded-lg border space-y-4 border-gray-200">
                                    <p className="text-lg font-bold text-gray-800 mb-6">Address Details</p>
                                    <div className="flex space-x-4">
                                        <div className="space-y-1 text-gray-400 flex flex-col items-center">
                                            <GoCircle className="text-xl" />
                                            <div className="h-6 border-l-2 border-gray-300"></div>
                                            <SlLocationPin className="text-xl" />
                                        </div>
                                        <div className="space-y-8">
                                            <p className="text-sm font-semibold text-gray-700">{serviceData?.pickUpPincode} <span className="text-gray-500">(Free Pickup)</span></p>
                                            <p className="text-sm font-semibold text-gray-700">{serviceData?.deliveryPincode} <span className="text-gray-500">(Delivery)</span></p>
                                        </div>
                                    </div>
                                    <div className='space-y-4'>

                                        <div className="flex justify-between text-sm font-semibold text-gray-700">
                                            <p>Weight (KG)</p>
                                            <div className="flex items-center">
                                                <RiWeightLine className="text-gray-500 text-lg mr-2" />
                                                <p>{serviceData?.weight}</p>
                                            </div>
                                        </div>

                                        <div className="flex justify-between text-sm font-semibold text-gray-700">
                                            <p>Payment Type(₹)</p>
                                            <div className="flex items-center">
                                                <MdOutlinePayment className="text-gray-500 text-lg mr-2" />
                                                <p className='uppercase'>{serviceData?.weight}</p>
                                            </div>
                                        </div>

                                        <div className="flex justify-between text-sm font-semibold text-gray-700">
                                            <p>COD Collectible Amount (₹)</p>
                                            <div className="flex items-center">
                                                <MdOutlinePayment className="text-gray-500 text-lg mr-2" />
                                                <p className='uppercase'>{serviceData?.weight}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <p className='border border-grey-400'></p>
                                    <div >
                                        <PriceCalculator orderAmount={Number(courierCharges[0]?.toFixed(2))} paymentModal='true' />

                                    </div>
                                    <div>
                                        <div className='flex justify-between text-sm md:font-semibold' >
                                            <p className='text-xl font-semibold'>Total Amount</p>
                                            <p className='text-xl font-semibold'>₹{Number(courierCharges[0]?.toFixed(2))}</p>
                                        </div>

                                        
                                    </div>

                                </div> */}
                            {/* </div> */}


                        </div>
                    </div>
                </div>
            </div >


            {/* <div className="mx-auto max-w-auto md:p-6 lg:px-8">
                <h1 className='font-bold text-xl mb-7'>{europeSelf.mainTitle}</h1>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {europeSelf.destinations.map((item, index) => (
                        <div
                            key={index}
                            className={`bg-white rounded-lg overflow-hidden`}
                        >
                            <div
                                className="relative cursor-pointer"
                            >
                                <img
                                    src={item.image}
                                    alt={item.destination}
                                    className="w-full h-48 object-cover"
                                />

                                <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-end text-white p-4">
                                    <h3 className="text-sm">To</h3>
                                    <p className="font-bold">{item.destination}</p>
                                    <div className="my-4">
                                        <h3 className="text-sm">Prepaid 0.5kg / <span className="font-bold">{item.price1}</span></h3>
                                        <h3 className="text-sm">Prepaid 1kg / <span className="font-bold">{item.price2}</span></h3>
                                    </div>

                                    <div className="">
                                        <h3 className="text-sm">Cash on Delivery 0.5kg / <span className="font-bold">{item.price3}</span></h3>
                                        <h3 className="text-sm">Cash on Delivery 1kg / <span className="font-bold">{item.price4}</span></h3>
                                    </div>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>
            </div> */}

            <div className='px-6 md:px-8' >
                <p className='font-bold text-slate-800 text-xl my-7'>Comprehensive Logistics Solutions with Nationwide Reach, Speed, and Advanced Technology</p>
                <div className='grid grid-cols-1 mb-3  rounded-none md:rounded-lg md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-2 gap-y-9 gap-x-8'>

                    <div className='bg-slate-50 p-6 rounded-lg'>
                        <div className="flex items-start">
                            <div className="rounded-md bg-black/5 p-2 ring-1 ring-black/10">
                                <TbLocationPin className="h-6 w-6 text-black" aria-hidden="true" />
                            </div>
                            <p className=" font-semibold self-center ms-3 text-black">Our Footprint</p>

                        </div>
                        <p className="mt-1 text-gray-500 text-sm ">
                            We have an extensive reach and strong footprint with over 1,200+ facility centers strategically located across 12 states and 5 union territories, offering end-to-end logistics solutions in more than 35,000+ PIN codes.
                        </p>
                    </div>
                    <div className='bg-slate-50 p-6 rounded-lg'>
                        <div className="flex items-start">
                            <div className="rounded-md bg-black/5 p-2 ring-1 ring-black/10">
                                <FaTruckRampBox className="h-6 w-6 text-black" aria-hidden="true" />
                            </div>
                            <p className=" font-semibold self-center ms-3 text-black">Dedicated Fleet Network</p>

                        </div>
                        <p className="mt-1 text-gray-500 text-sm">
                            Our integrated transportation network comprising of over 1,000 runs daily, serviced through dedicated fleet-runs, provides unmatched capability to transport anywhere in India.
                        </p>
                    </div>
                    <div className='bg-slate-50 p-6 rounded-lg'>
                        <div className="flex items-start">
                            <div className="rounded-md bg-black/5 p-2 ring-1 ring-black/10">
                                <AiTwotoneSafetyCertificate className="h-6 w-6 text-black" aria-hidden="true" />
                            </div>
                            <p className=" font-semibold self-center ms-3 text-black">Speed and Reliability</p>

                        </div>
                        <p className="mt-1 text-gray-500 text-sm">
                            Our delivery of Shipment on committed schedules enabled through strategically positioned hubs and dedicated-GPS enabled fleet of vehicles, provide unmissable speed and reliability.
                        </p>
                    </div>
                    <div className='bg-slate-50 p-6 rounded-lg'>
                        <div className="flex items-start">
                            <div className="rounded-md bg-black/5 p-2 ring-1 ring-black/10">
                                <GrSystem className="h-6 w-6 text-black" aria-hidden="true" />
                            </div>
                            <p className=" font-semibold self-center ms-3 text-black">Technology and Automation</p>

                        </div>
                        <p className="mt-1 text-gray-500 text-sm">
                            Our quest for technology and automation to efficiently delivery Shipment is never-ending. We enable order fulfillment by engaging next-generation cutting-edge technology, data sciences and seamless integration at every step.
                        </p>
                    </div>
                    <div className=' bg-slate-50 p-6 rounded-lg'>
                        <div className="flex items-start">
                            <div className="rounded-md bg-black/5 p-2 ring-1 ring-black/10">
                                <GiSkills className="h-6 w-6 text-black" aria-hidden="true" />
                            </div>
                            <p className=" font-semibold self-center ms-3 text-black">Professional and Skilled Force</p>

                        </div>
                        <p className="mt-1 text-gray-500 text-sm">
                            Our 15,000+ well-trained and skilled force ensure highest standards of quality, performance and response 24 X 7 everyday. They are powered by optimal logistics solutions.
                        </p>
                    </div>
                    <div className=' bg-slate-50 p-6 rounded-lg'>
                        <div className="flex items-start">
                            <div className="rounded-md bg-black/5 p-2 ring-1 ring-black/10">
                                <GrSchedules className="h-6 w-6 text-black" aria-hidden="true" />
                            </div>
                            <p className=" font-semibold self-center ms-3 text-black">Smart Scheduling</p>

                        </div>
                        <p className="mt-1 text-gray-500 text-sm">
                            Our digitized end-to-end operations enhance the speed of our pick-up and delivery services leading to utmost efficiency through improved utilization.
                        </p>
                    </div>
                </div>
            </div >


            <div className='px-6 md:px-8 py-10'>
                <div className='space-y-6'>
                    <p>Our AlgarXpress company is dedicated to making the shipping process as simple and efficient as possible. One of the key tools we offer is a free, easy-to-use calculator that helps you calculate Shipment charges based on a variety of factors. This calculator not only saves you time but also provides transparency, allowing you to plan your shipments effectively and avoid unexpected costs. Whether you are an individual sending a single package or a business managing frequent shipments, our calculator is designed to accommodate your needs, making the entire process more streamlined and efficient.</p>
                    <div className='space-y-7'>
                        <p className='font-semibold text-lg'>User-Friendly and Accessible
                        </p>
                        <p>We understand that shipping logistics can often be complex, especially when trying to determine the cost of sending a parcel. That's why we’ve designed our calculator to be intuitive and easy to use, regardless of your level of experience. With just a few simple inputs, you can quickly get an accurate estimate of the Shipment charges for your parcel.</p>
                        <p>The calculator takes into account all the factors that influence shipping costs, such as the weight and dimensions of the package, the destination, the type of service you choose (standard, express, etc.), and any additional services like insurance or signature confirmation. This ensures that you get a comprehensive estimate that reflects all potential costs, helping you avoid any surprises when it's time to ship your parcel.</p>
                        <p>Our free calculator is accessible on any device, whether you're using a desktop computer, a tablet, or a smartphone. This flexibility means that no matter where you are, you can easily calculate Shipment charges and plan your shipments accordingly. We recognize that many of our customers are on the go, and our mobile-friendly platform allows you to access our services whenever and wherever you need them.</p>
                    </div>

                    <div className='space-y-7'>
                        <p className='font-semibold text-lg'>Customization for Business and Personal Use
                        </p>
                        <p>Our Shipment charge calculator is not just a generic tool—it’s designed to cater to both individual users and businesses with specific shipping needs. For businesses, managing logistics can be particularly challenging, especially when dealing with high volumes of shipments or time-sensitive deliveries. Our calculator provides businesses with the ability to quickly determine the most cost-effective shipping options for their needs, helping to manage budgets and improve overall efficiency.</p>
                        <p>Small businesses, in particular, benefit from this tool by being able to calculate shipping costs in real time, giving them the ability to offer accurate pricing to customers. This can improve customer satisfaction, as businesses can provide shipping rates directly on their websites or e-commerce platforms, ensuring transparency from the start. For larger enterprises, the calculator can be integrated into their logistics workflows, allowing for seamless management of multiple shipments while maintaining control over costs.</p>
                        <p>For personal use, the calculator simplifies the process of sending gifts, documents, or personal items, ensuring that you know exactly what to expect in terms of pricing. Whether you're sending a birthday present to a loved one across the country or shipping important documents internationally, our calculator helps you make informed decisions about the best shipping options for your needs.</p>
                    </div>

                    <div className='space-y-7'>
                        <p className='font-semibold text-lg'>Transparent Pricing with No Hidden Fees
                        </p>
                        <p>One of the main advantages of using our Shipment charge calculator is the transparency it provides. Shipping costs can sometimes be confusing, with hidden fees or surcharges that aren’t always clear upfront. Our calculator eliminates this uncertainty by giving you a detailed breakdown of the costs associated with your shipment.</p>
                        <p>We believe in honest, upfront pricing, and our goal is to help you avoid any unpleasant surprises. The quote you receive from our calculator is what you can expect to pay, with no hidden fees or unexpected charges down the line. This level of transparency is part of our commitment to providing exceptional service and ensuring that our customers can trust us with their shipping needs.</p>
                    </div>
                    <div className='space-y-7'>
                        <p className='font-semibold text-lg'>Time-Saving and Efficient
                        </p>
                        <p>Time is a valuable resource, and our Shipment charge calculator is designed to save you as much time as possible. Instead of spending hours comparing rates from different couriers or trying to estimate shipping costs manually, our calculator does all the work for you in just a few seconds. This efficiency is especially important for businesses that manage high volumes of shipments and need to streamline their logistics operations.</p>
                        <p>By providing an instant quote, our calculator allows you to make quick decisions about your shipping options, ensuring that you can focus on other aspects of your business or personal life. And because the entire process is automated, there’s no need to contact customer service or wait for a response—everything you need is available at your fingertips.</p>
                    </div>

                    <div className='space-y-7'>
                        <p className='font-semibold text-lg'>A Commitment to Customer Satisfaction
                        </p>
                        <p>Above all, our Shipment charge calculator reflects our commitment to customer satisfaction. We understand that shipping can sometimes be stressful, especially when dealing with tight deadlines or valuable parcels. Our calculator is designed to take the guesswork out of the process, giving you the information you need to make informed decisions and ensuring that your parcels are delivered on time and within budget.</p>
                        <p>Whether you're a business owner managing a complex supply chain or an individual sending a personal package, we are here to support you every step of the way. Our customer service team is available to assist with any questions or concerns, and we are constantly working to improve our services based on feedback from our customers.</p>
                    </div>

                </div>


            </div >

            {/* {openCal && serviceData && <CalculateModel show={openCal} onClose={() => setOpenCal(false)} serviceData={serviceData} courierCharges={courierCharges} />} */}
            <div>
                <Footer />
            </div>
        </>
    )
}

export default CalculatorCourier;
